// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdfpreview-container .react-pdf__Page__canvas {
	width: 100%;
	height: auto;
}
.image-preview {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pages/NewEsign/pdfpreview-new.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB","sourcesContent":[".pdfpreview-container .react-pdf__Page__canvas {\n\twidth: 100%;\n\theight: auto;\n}\n.image-preview {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
